import React, { useEffect, useRef } from "react";
import { useTheme, ITheme } from 'src/theme-revamp';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import Lottie from "react-lottie-player";
import loadingAnimation from '@assets/images/sl-r3-loader.json';

const ModalContainer = styled.div<StyledProps>`
  position: fixed;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  overflow-x: hidden;
  background-color: rgba(51, 51, 51, 0.85);
  pointer-events: none;
  opacity: 0;
  transition: opacity 250ms 700ms ease;
  box-shadow: none;
`
const ModalContent = styled.div<StyledProps>`
  overflow-x: hidden;
  position: relative;
  width: 100%;
  max-height: 620px;
  min-height: 320px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  padding: 30px 20px;
  align-self: center;
  box-shadow: none;
  opacity: 0;
  transform: scale(0.6);
  transition: opacity 250ms 250ms ease, transform 300ms 250ms ease;
  transform: scale(0);
  display: flex;
  justify-content: center;
`

const Body = styled.div<StyledProps>`
  //background-color: ${props => props.theme?.colors.white + ''};
  width: 300px;
  height: 300px;
  margin: 0;
  padding: 20px;
  overflow-y: hidden;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const SpinnerElement = styled.div<StyledProps>`
  height: 154px;
  width: 154px;
  border-radius: 50%;
  position: absolute;
  border: 20px solid ${props => props.theme?.colors.white + ''};
  border-right-color: ${props => props.theme?.colors.primary + ''};
  border-top-color: ${props => props.theme?.colors.primary + ''};
  animation: 1s spin infinite linear;
  @keyframes spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
`

const TextWrapper = styled.div`
  z-index: 1;
  position: absolute;
`

const visible = css`
  pointer-events: auto;
  opacity: 1;
  transition: all 300ms ease-in-out;
`

const visibleContent = css`
  opacity: 1;
  transform: scale(1);
  transition: opacity 250ms 500ms ease, transform 350ms 500ms ease;
`

interface StyledProps {
  theme?: ITheme;

}

export interface SpinnerProps {
  show: boolean;
}


function Spinner({ show }: SpinnerProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const contentModalRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();

  useEffect(() => {
    if (!modalRef.current || !contentModalRef.current) {
      return
    }
    if (show) {
      modalRef?.current.classList.add(visible);
      contentModalRef.current.classList.add(visibleContent);
    } else {
      modalRef.current.classList.remove(visible);
      contentModalRef.current.classList.remove(visibleContent);
    }
  }, [show]);

  return (
    <ModalContainer ref={modalRef} theme={theme}>
      <ModalContent ref={contentModalRef}>
        <Body theme={theme}>
          <Lottie loop={true} animationData={loadingAnimation} play={true} style={{ margin:"auto", width: 300, height: 300 }}></Lottie>
        </Body>
      </ModalContent>
    </ModalContainer>
  );
};

Spinner.defaultProps = {
  show: false,
}

export default Spinner;
